<template>
    <div class="c_form-item">
        <p
            :class="isTable ? 'f_label':''"
            class="form_label"
        >{{ header.title }}</p>
        <p class="color_9 maohao">:</p>
        <!-- Upload 上传 -->
        <RenderUpload
            v-if="header.type === 'upload'"
            :data="data"
            :header="header"
            :is-table="isTable"
        />
        <!-- CustomUpload 自定义组件上传 -->
        <RenderUploadCustom
            v-else-if="header.type === 'CustomUpload'"
            :data="data"
            :header="header"
        />
        <!-- 其他表单 -->
        <p
            v-else
            class="form_value"
        >{{ data[header.field] }}</p>
    </div>
</template>

<script>
import RenderUpload from './renderUpload.vue'
import RenderUploadCustom from './renderUploadCustom.vue'

export default {
    name: 'RenderForm',
    components: { RenderUpload, RenderUploadCustom },
    mixins: [],
    props: {
        data: {
            type: Object,
            default: null
        },
        header: {
            type: Object,
            default: null
        },
        isTable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },

    created() {
        console.log('this.isTable', this.isTable)
    },

    methods: {
    }
}
</script>

<style rel="stylesheet/less" lang="less">
.c_form-item {
    width: 100%;
    display: flex;

    .form_label {
        flex: 0 0 90px;
        color: #999;
        text-align: right;
        margin-right: 10px;
        display: inline-block;
        text-align: justify;
        text-align-last: justify;
        text-justify: inter-ideograph;
        flex-shrink: 0;
        &:after {
            display: inline-block; /*行内元素*/
            content: '';
            width: 100%; /*可以挤掉文字，保证不跟文字在同一行*/
            height: 0;
            visibility: hidden;
        }
    }

    .f_label {
        color: #000 !important;
    }

    .form_value {
        flex: 1;
        padding: 0 10px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .img_wrap {
            display: flex;
            align-items: center;

            .img {
                margin: 0 5px;
            }
        }
    }
}
</style>
